module.exports = __webpack_public_path__ + "static/img/bg_member.6ca29df1.png";